module.exports = __webpack_public_path__ + "img/andy-mac.c8fa5b79.png";